export default function NumberNotString(value) {
  if (value === "") return Number(value)
  return value
}
